/**
 * AlertIcon theme values.
 */
import { Components } from "@oui/system/components"
import { css } from "@oui/system"
// import palettes from "../palettes"
// import spacing from "../spacing"

const base = css``

// const successGreen = "#76b417"

const appearances: Components["Alert"]["Icon"]["appearances"] = {
  default: css`
    ${base};
  `,
  success: css`
    ${base};
  `,
  warning: css`
    ${base};
  `,
  danger: css`
    ${base};
  `
}

export default { appearances }
